import { formatInterviewSchedule } from 'features/sendouts/common/utils';
import startCase from 'lodash/startCase';

export const formatResponse = response => {
  const formattedData = response.data.interviews.map(item => ({
    ...item,
    interviewType: item?.interviewType?.title ?? null,
    interviewDate: formatInterviewSchedule({
      startTimestamp: item.start_timestamp,
      endTimestamp: item.end_timestamp,
      timezone: item.interview_time_zone
    }),
    otherInterviewer: item.full_name ? startCase(item.full_name) : null
  }));
  return { ...response, data: { ...response.data, data: formattedData } };
};
